import { Component, computed, inject, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from '@lib/auth/data-access';
import { FeatureToggleService } from '@lib/feature-toggle/data-access';
import { FeatureToggleType } from '@lib/feature-toggle/models';
import { ToastMessageOptions } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'lib-notification-release-note-notification',
  imports: [
    RouterModule,
    ToastModule,
    AvatarModule,
    AvatarGroupModule,
    TooltipModule
  ],
  templateUrl: './release-note-notification.component.html',
  styleUrl: './release-note-notification.component.scss',
})
export class ReleaseNoteNotificationComponent {
  public message = input.required<ToastMessageOptions>();
  
  // inject
  private router = inject(Router);
  public authService = inject(AuthService);
  private featureToggleService = inject(FeatureToggleService);
  // public
  public isNotificationFeatureEnabled = computed(() => { return this.featureToggleService.tenantFeaturesComputedSignal().some(feature => feature.id === FeatureToggleType.Notifications && feature.isEnabled) })
}
